import { useLocation } from "react-router-dom";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import AdminFormLayout from "../components/AdminFormLayout";
import ButtonComponent from "../../components/ButtonComponent";
import { getAdminUploadHeaders } from "../../utils/adminApi";

const EditCategory = () => {
  const location = useLocation();
  const { categoryId } = location.state;
  const { categoryName } = location.state;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: categoryName,
  });

  const handleImageChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: name === "image" ? files[0] : value,
    }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const productData = new FormData();
      productData.append("name", formData.name);

      if (formData.image) {
        productData.append("image", formData.image);
      }

      await axios.put(
        `https://api.michelbandalidesign.com/api/category/${categoryId}`,
        productData,
        { headers: getAdminUploadHeaders() }
      );
      toast.success("Category updated successfully");
      navigate("/admin/category");
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Failed to update category");
    }
  };

  return (
    <AdminFormLayout title="Edit Category" backTo="/admin/category" backLabel="Back to Categories">
      <form encType="multipart/form-data">
        <div className="admin-form-group">
          <label htmlFor="name">Category Name</label>
          <input
            type="text"
            className="form-control admin-all-forms-inputs"
            id="name"
            name="name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
        </div>

        <div className="admin-form-group">
          <label htmlFor="image">Category Image</label>
          <input
            type="file"
            className="form-control admin-all-forms-inputs"
            id="image"
            name="image"
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>

        <ButtonComponent onClick={handleUpdate} type="submit">
          Update Category
        </ButtonComponent>
      </form>
    </AdminFormLayout>
  );
};

export default EditCategory;
